import * as React from 'react'
import '../ReportsItem.scss'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import { Elements } from '@tfo/common'
const { Heading2, Label } = Elements

export interface IReportsItemProps {
	date: Date
	label: string
	emptyDateLabel?: string
}

const ReportsItemDate = (props: IReportsItemProps & WrappedComponentProps) => (
	<div className={'ReportsItem__Cell ReportsItem__Cell--alignBottom'}>
		{props.date && props.intl.formatDate(props.date).length > 0 ? (
			<div className={'ReportsItem__Date'}>
				<div className={'ReportsItem__DateNumber'}>
					<Heading2>
						{props.intl.formatDate(props.date, { day: 'numeric' })}
					</Heading2>
				</div>
				<div className={'ReportsItem__DateDetails'}>
					<Label>{props.label}</Label>
					<Label>
						{props.intl.formatDate(props.date, {
							month: 'long',
							year: 'numeric',
						})}
					</Label>
				</div>
			</div>
		) : (props.emptyDateLabel 
			? <div className={'ReportsItem__EmptyDateLabel'}><Label>{props.emptyDateLabel}</Label></div>
			: null)}
	</div>
)

export default injectIntl(ReportsItemDate)
